export default __webpack_public_path__ + "static/media/signout.7c659585.svg";